import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Avatar, Button, Icon, List } from "antd/lib/index";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { deleteViaje } from "../../../redux/actions/viajes";
import { selectAllViajes } from "../../../redux/selectors/viajes";

const IconText = ({ type, text }) => (
  <span>
    <Icon type={type} style={{ marginRight: 8 }} />
    {text}
  </span>
);

class ViajesList extends Component {
  render() {
    return (
      <List
        style={{ margin: 50 }}
        itemLayout="vertical"
        size="large"
        dataSource={this.props.viajes}
        renderItem={item => (
          <List.Item
            key={item.key}
            actions={[
              <IconText type="star-o" text="156" />,
              <IconText type="like-o" text="156" />,
              <IconText type="message" text="2" />
            ]}
            extra={
              <img
                width={272}
                alt="logo"
                src="https://gw.alipayobjects.com/zos/rmsportal/mqaQswcyDLcXyDKnZfES.png"
              />
            }
          >
            <List.Item.Meta
              avatar={<Avatar src={item.avatar} />}
              title={<Link to={`/viajes/${item.key}`}>{item.nivel}</Link>}
              description={item.description}
            />
            {item.descripcion.split("\n").map(function(item, h) {
              return (
                <span key={h}>
                  {item}
                  <br />
                </span>
              );
            })}
            <Button>
              <Link to={`/viajes/${item.key}/edit`}>Edit Viaje</Link>
            </Button>
            <Button onClick={() => this.props.onDeleteViaje(item.key)}>
              Delete Viaje
            </Button>
          </List.Item>
        )}
      />
    );
  }
}

const mapStateToProps = state => {
  const viajes = selectAllViajes(state);
  return {
    viajes
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ onDeleteViaje: deleteViaje }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViajesList);
